import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';

/**
 * 物料單位列表。
 * `GET /mtr/{mtrId}/units` → `parseVer4ListResponse`（固定 sort_order ASC；含 ACTIVE／INACTIVE）。
 *
 * @param {string} mtrId
 */
export async function fetchMtrUnitList(mtrId) {
  const { data: raw } = await request.get(`/mtr/${mtrId}/units`);
  return parseVer4ListResponse(raw);
}
